// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"bf0d413e","158":"99fc500c","311":"93e63dbe","404":"79991437","551":"765a92b1","927":"105c74df"}[chunkId] + ".js";
};